import * as React from 'react';

import { StoreDependencies } from '@stores/index';
import { MobXProviderContext } from 'mobx-react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useStores = (): StoreDependencies => React.useContext<any>(MobXProviderContext);
